import { Heading } from '@react-email/components';

const headingOne = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return (
            <Heading as="h1" {...attributes} {...element.attributes}>
                {children}
            </Heading>
        );
    },
    PreviewElement: ({ attributes, children }) => {
        return (
            <Heading as="h1" {...attributes}>
                {children}
            </Heading>
        );
    },
};

export default headingOne;
